export default __webpack_public_path__ + "static/media/grass.2e3cbdcc.jpg";